import React, { useEffect, useState } from 'react'
import Navbar from './global-components/navbar'
import PageHeader from './global-components/page-header'
import Team from './section-components/team'
import Footer from './global-components/footer'
import RegisterInterest from './section-components/RegisterInterest/RegisterInterest'
import RealHome from './section-components/RealHome/RealHome'
import AzcaStory from './section-components/AzcaStory/AzcaStory'
import AzcaConstruction from './section-components/AzcaConstruction/AzcaConstruction'
import OurMission from './section-components/OurMission/OurMission'
import AboutMD from './section-components/AboutMD/AboutMD'
import useFetch from '../Hooks/useFetch'
import MissionImage from '../assets/img/About-Images/mission.jpg'
import VisionImage from '../assets/img/About-Images/vission.jpg'

const About = () => {
  const { data } = useFetch()
  const myField = data?.items.find((item, index) => {
    if (item.sys.id === '1VpU31BISPlAMHez6ODkDz') {
      return item
    }
  })

  // console.log(myField?.fields)

  // console.log(data)

  return (
    <div>
      <Navbar />
      <PageHeader
        headertitle='Live in the heart of town'
        subheader='About'
        Imagefile={myField?.fields.phTitle.fields.file.url}
      />
      <RealHome
        title={myField?.fields.rhTitle}
        desc={myField?.fields.rhParagraph}
      />
      <AzcaStory />
      <OurMission
        img={myField?.fields.omImg.fields.file.url}
        title={myField?.fields.omTitle}
        desc={myField?.fields.omParagraph}
      />
      <AzcaConstruction data={data} />
      <OurMission
        img={myField?.fields.om2img.fields.file.url}
        title={myField?.fields.om2title}
        desc={myField?.fields.om2paragraph}
      />

      <AboutMD data={data} />
      {/* <Mission />
      <AboutUs /> */}
      {/* <ServiceTwo /> */}
      <Team data={myField?.fields} />
      {/* <Client /> */}
      <RegisterInterest />
      <Footer />
    </div>
  )
}

const realhome = {
  title: 'real home, real communities, local expertise',
  desc: `We believe a home should be much more than a roof over your head. A
  real home is a place to feel rooted to connect with family and those
  around you`,
}

const vision = {
  img: VisionImage,
  title: 'Our Vision',
  desc: `Help you to make the best investment in Real Estate & plan your future.`,
}
const mission = {
  img: MissionImage,
  title: 'Our Mission',
  desc: `Our mission is to modernize and enhance the experience of buying
  and selling Real Estate by cultivating a spirit of collaboration,
  innovation & integrity`,
}

export default About
